import { useRedux } from "shared/lib/useRedux"

import { useProjectRequestMonitor } from "entities/projects/model/useProjectRequestState"

export function useProjectState(id: string | null) {
  const { isUpdatingChildren } = useProjectRequestMonitor({ projectID: id })
  const { isPending } = useRedux(({ projects }) => ({
    isPending: id ? !!projects[id]?.isPending : false
  }))

  return {
    isUpdatingChildren,
    isPending
  }
}
